<template>
  <LinkLocale
    to="/"
    :title="websiteName"
    :class="['tw-block tw-h-full', props.customClass]"
  >
    <img
      :src="logo"
      :alt="websiteName"
      class="tw-h-full tw-w-auto tw-max-w-[164px] tw-object-contain"
      loading="lazy"
    />
  </LinkLocale>
</template>

<script lang="ts" setup>
const props = defineProps({
  customClass: {
    type: String,
    default: 'md:tw-py-5',
  },
})

const websiteInfoStore = useWebsiteInfoStore()
const logo = computed(() => websiteInfoStore?.logo?.large || '')
const websiteName = computed(() => websiteInfoStore?.name || '')
</script>
